import { colorSystem } from "goi_common";

const title = "대구 경북 장례 정보 - 고이장례연구소";

export const parlorRegion = {
  defaultMetaData: {
    pageOgTitle: title,
    pageDescription: `대구 경북 장례식장 견적, 대구 경북 장례식장 상세 비용, 가장 저렴한 대구 경북 장례식장, 대구 경북 장례식장 비용 정보, 주변 장례식장과 비교하기 - 고이장례연구소`,
    pageKeywords:
      "대구 장례식장 추천, 경북 장례식장 추천, 장례 상담, 장례, 장례식, 가족장, 무빈소장례, 장례지도사, 장례식장, 장례 비용, 상조, 상조 회사, 상조회, 상조가입, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    pageOgDescription: `대구 경북 장례식장 견적, 대구 경북 장례식장 상세 비용, 가장 저렴한 대구 경북 장례식장, 대구 경북 장례식장 비용 정보, 주변 장례식장과 비교하기 - 고이장례연구소`,
    pageOgImage: "",
  },

  layout: {
    headTitle: title,
    layoutStyle: {
      background: "white",
      borderBottom: "1px solid #ebebeb",
      color: "black",
      height: "70px",
    },
    ctaButtonStyle: { border: "1px solid #F18334", color: "#F18334" },
  },

  targetSidos: ["22", "37"],

  regionColor: colorSystem.orange,

  bestParlorIds: [35, 74, 86, 149, 631],

  baseUrl: "https://dggb-portal.funeralblog.co.kr",
};
